import BaseModelAPI from '../BaseModelAPI';

export default class MappingAndonProductionList extends BaseModelAPI {

	static entity = 'mappingandonproductionlist'
	static entityName = 'mappingandonproduction';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
